import React from "react"
import { Box, Typography } from "@mui/material"

const TimeFilter = ({ options, activeOption, onOptionChange }) => {
  return (
    <Box sx={{ display: "flex", gap: "32px" }}>
    {options.map((tab) => (
      <Box key={tab} sx={{ position: "relative" }}>
        <Typography
          onClick={() => onOptionChange(tab)}
          sx={{
            color: activeOption === tab ? "#061522" : "#405261",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: activeOption === tab ? 500 : 400,
            lineHeight: "18px",
            cursor: "pointer",
            paddingBottom: "16px",
          }}
        >
          {tab}
        </Typography>
        {activeOption === tab && (
          <Box
            sx={{
              position: "absolute",
              bottom: "-1px",
              left: 0,
              right: 0,
              height: "2px",
              backgroundColor: "#148DFD",
              zIndex: 1,
            }}
          />
        )}
      </Box>
    ))}
  </Box>
  )
}

export default TimeFilter
